import { ref, computed } from 'vue'
import {defineStore} from "pinia";

export const useSharedHeightMobileMenu  = defineStore('use-shared-height-mobile-menu', ()=>  {
    const sharedHeight: Ref<number> = ref(0)
    const isHeaderFixed: Ref<boolean> = ref(false)

    return { sharedHeight, isHeaderFixed }
})
